<template>
  <dialog-add
    icon="business_center"
    :title="title"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-creator-program-billing-account class="elevation-1" @saved="$emit('saved')" />
    </template>
  </dialog-add>
</template>

<script>
export default {
  emits: ['saved'],
  methods: {
    onCancel() {
      this.$router.push({ name: 'creator-program-billing-accounts', query: this.$route.query });
    },
  },
  computed: {
    title() {
      if (this.$route.name === 'creator-program-billing-accounts-new') {
        return this.$t('create_billing_account');
      } else {
        return this.$t('change_billing_account');
      }
    },
  },
};
</script>
